export class StoreStatus {
    public storeGroupCode: string;
    public lastLoyaltyTransaction: Date;
    public totalEnquiries: number;
    public failureCount: number;
    public fraudTriggerCount: number = 0;
    public total: number;
    public inactive: boolean;
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/views/dashboards/store-status/store-status.ts